<template>
    <b-input-group class="input-group-merge">
      <b-form-input
      v-model="internalValue"
      type="text"
      :placeholder="placeholder"
      size="sm"
      ></b-form-input>
      <b-input-group-append is-text>
        <feather-icon icon="SearchIcon" />
      </b-input-group-append>
    </b-input-group>
  </template>
  
  <script>
  import {
  BButton,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BModal,
  BFormGroup,BRow,BCol,BInputGroup,BInputGroupAppend
} from "bootstrap-vue";
  export default {
    components: {
    BButton,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormGroup,BRow,BCol,BInputGroup,BInputGroupAppend,
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
  };
  </script>